export function addCSPNonceToHtml(html: string, nonce: string): string {
  if (!html) return html;

  // Don't add nonce if it's invalid - better to leave it out than add "undefined"
  if (!nonce || nonce === "undefined" || nonce === "null") {
    console.warn(
      "[addCSPNonceToHtml] Skipping nonce addition - invalid nonce value:",
      nonce
    );
    return html;
  }

  // Regular expressions to match the required tags
  // Fixed: \s* instead of \s+ to match tags with or without attributes
  const scriptTagRegex = /<script(\s+[^>]*?)?>/gi;
  const linkTagRegex = /<link(\s+[^>]*?)?>/gi;
  const styleTagRegex = /<style(\s*[^>]*?)\s*>.*?<\/style>/gis;
  const allTagsWithStyleAttribute =
    /<\s*\w+[^>]*\s+style\s*=\s*["'][^"']*["'][^>]*>/gi;

  // Helper function to add nonce to a tag if it is missing
  const addNonceToTag = (tag: string, nonce: string): string => {
    // Check if nonce already exists to avoid duplicates
    if (tag.includes(`nonce="${nonce}"`)) return tag;

    // Add nonce attribute to the tag
    return tag.replace(/<(\w+)(\s+[^>]*)?>/i, (_, tagName, attributes) => {
      const attrs = attributes || "";
      return `<${tagName}${attrs} nonce="${nonce}">`;
    });
  };

  // Add nonce to all <script> tags
  html = html.replace(scriptTagRegex, (match) => addNonceToTag(match, nonce));

  // Add nonce to all <link> tags (typically for stylesheets)
  html = html.replace(linkTagRegex, (match) => addNonceToTag(match, nonce));

  // Add nonce to all <style> tags
  html = html.replace(styleTagRegex, (match) => addNonceToTag(match, nonce));

  // Add nonce to all HTML tags having style attribute
  html = html.replace(allTagsWithStyleAttribute, (match) =>
    addNonceToTag(match, nonce)
  );

  return html;
}
